"use client";

import * as React from "react";
import type { ImageProps } from "./image";

export type ImageProviderComponentProps = Omit<ImageProps, "aspectRatio"> & {
  /**
   * Resolves the URL for a requested width. Set when the caller supplied its own
   * `srcSet`, so the override serves those candidates instead of re-encoding `src`.
   * Matches the next/image `loader` signature.
   */
  loader?: (params: { src: string; width: number; quality?: number }) => string;
};

type ImageContextValue = {
  Override?: React.ComponentType<ImageProviderComponentProps>;
};

export const ImageContext = React.createContext<ImageContextValue>({});

export function ImageProvider(props: {
  component: React.ComponentType<ImageProviderComponentProps>;
  children: React.ReactNode;
}): React.ReactNode {
  const contextValue = React.useMemo(
    () => ({ Override: props.component }),
    [props.component]
  );

  return (
    <ImageContext.Provider value={contextValue}>
      {props.children}
    </ImageContext.Provider>
  );
}
